import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Users, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getFullName } from "../../services/common/util";

export function DeskOverview({ desks, timeRange = "today" }) {
    const navigate = useNavigate();

    const handleAgentClick = (agentId) => {
        navigate(`/agent/${agentId}`);
    };

    return (
        <>
        <Card className="border-gray-200 bg-white">
            <CardHeader className="pb-3 bg-gray-50 border-b border-gray-200">
                <CardTitle className="text-sm font-semibold text-gray-800 uppercase tracking-wide flex items-center">
                    <div className="p-1.5 bg-red-50 rounded mr-2">
                        <Users className="h-4 w-4 text-red-600" />
                    </div>
                    Teams Overview
                </CardTitle>
            </CardHeader>
            <CardContent>
                {desks && desks.length ? (
                    <Accordion type="single" collapsible className="w-full">
                        {desks.map((desk) => (
                            <AccordionItem key={desk._id} value={desk._id} className="border-gray-200">
                                <AccordionTrigger className="text-left hover:bg-gray-50 rounded px-2 -mx-2 transition-colors">
                                    <div className="flex items-center justify-between w-full mr-4">
                                        <span className="text-sm font-medium text-gray-900">{desk.name}</span>
                                        <div className="flex items-center gap-3 text-xs text-gray-500">
                                            <span className="bg-red-50 text-red-700 px-2 py-0.5 rounded font-medium">{desk.agents?.length || 0} agents</span>
                                            <span className="text-gray-300">•</span>
                                            <span>{desk.leadCount || 0} leads</span>
                                            <span className="text-gray-300">•</span>
                                            <span>{desk.callCount || 0} calls</span>
                                        </div>
                                    </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                    <div className="pt-3 space-y-3 bg-gray-50 -mx-4 px-4 py-3 rounded border border-gray-200">
                                        <div>
                                            <p className="text-xs font-semibold text-red-700 uppercase tracking-wide mb-1">Manager</p>
                                            <p className="text-sm text-gray-900 font-medium">
                                                {desk.manager ? getFullName(desk.manager) : "Not assigned"}
                                            </p>
                                        </div>

                                        <div>
                                            <p className="text-xs font-semibold text-red-700 uppercase tracking-wide mb-2">Team Members</p>
                                            <div className="space-y-1.5">
                                                {(!desk.agents || !desk.agents.length) && (
                                                    <p className="text-sm text-gray-500">No members assigned</p>
                                                )}
                                                {desk.agents && desk.agents.length > 0 &&
                                                    desk.agents.map((member) => (
                                                        <div
                                                            key={member._id}
                                                            className="p-2 bg-white border border-gray-200 rounded hover:border-red-300 hover:shadow-sm transition-all"
                                                        >
                                                            <div className="flex items-center justify-between mb-1.5">
                                                                <button
                                                                    onClick={() => handleAgentClick(member._id)}
                                                                    className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors"
                                                                >
                                                                    {getFullName(member)}
                                                                </button>
                                                                <div className="flex items-center text-xs text-gray-500 bg-gray-50 px-2 py-1 rounded">
                                                                    <Phone className="h-3 w-3 mr-1 text-red-600" />
                                                                    {member.callCount || 0}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                ) : (
                    <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
                        <Users className="h-12 w-12 text-gray-300 mx-auto mb-2" />
                        <p className="text-sm text-gray-500">No teams available</p>
                    </div>
                )}
            </CardContent>
        </Card>
        </>
    );
}
